var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6667 11.7797V13.7797C14.6675 13.9654 14.6294 14.1492 14.555 14.3193C14.4807 14.4894 14.3716 14.6421 14.2348 14.7676C14.0979 14.8932 13.9364 14.9887 13.7605 15.0482C13.5847 15.1077 13.3983 15.1298 13.2134 15.1131C11.1619 14.8902 9.19137 14.1892 7.46004 13.0664C5.84926 12.0428 4.48359 10.6772 3.46004 9.06641C2.33336 7.32721 1.6322 5.34707 1.41337 3.28641C1.39671 3.10205 1.41862 2.91625 1.4777 2.74082C1.53679 2.5654 1.63175 2.4042 1.75655 2.26749C1.88134 2.13077 2.03324 2.02155 2.20256 1.94675C2.37189 1.87196 2.55493 1.83325 2.74004 1.83307H4.74004C5.06357 1.82989 5.37723 1.94446 5.62254 2.15543C5.86786 2.3664 6.02809 2.65937 6.07337 2.97974C6.15779 3.61978 6.31434 4.24822 6.54004 4.85307C6.62973 5.09169 6.64915 5.35102 6.59597 5.60033C6.5428 5.84964 6.41928 6.07848 6.24004 6.25974L5.39337 7.10641C6.34241 8.77544 7.72434 10.1574 9.39337 11.1064L10.24 10.2597C10.4213 10.0805 10.6501 9.95697 10.8994 9.9038C11.1488 9.85063 11.4081 9.87004 11.6467 9.95974C12.2516 10.1854 12.88 10.342 13.52 10.4264C13.8439 10.4721 14.1396 10.6352 14.3511 10.8847C14.5625 11.1343 14.6748 11.4528 14.6667 11.7797Z",
    stroke: "#FFD700",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPhone);
export default __webpack_public_path__ + "static/media/footer_phone.befbb0f3286d16cf950df1fb0cb6353c.svg";
export { ForwardRef as ReactComponent };